export default __webpack_public_path__ + "static/media/7331541.db0cdc11.jpg";